import React, { useState } from 'react';
import { Button } from 'antd';
import { CALENDLY_LINK } from 'constants/common';
import { EWebinarScheduleType } from 'types/common';
import WebinarBooking from 'components/WebinarBooking';
import RocketImg from 'assets/marketing/pro-listing-rocket.png';
import s from './s.module.less';

type Props = {
    onSetupClick?: () => void;
};

const ProListingUpsellCard: React.FC<Props> = ({ onSetupClick }) => {
    const [showWebinarBooking, setShowWebinarBooking] = useState(false);

    return (
        <div className={s.wrap}>
            <img className={s.rocketImg} src={RocketImg} alt="" />
            <div className={s.content}>
                <div className={s.header}>
                    <p className={s.label}>You&rsquo;re missing patients</p>
                    <p className={s.headline}>
                        Your impression share is 1%.
                        <br />
                        Pro-Listing providers in your area average 12%.
                    </p>
                </div>
                <p className={s.description}>
                    That means 11 out of every 12 patients searching for your specialty in your state see other
                    providers first. Pro-Listing puts you at the top — you only pay when a patient books.
                </p>
                <div className={s.stats}>
                    <div className={s.statItem}>
                        <p className={s.statValue}>12x</p>
                        <p className={s.statLabel}>more visibility</p>
                    </div>
                    <div className={s.statItem}>
                        <p className={s.statValue}>3.2x</p>
                        <p className={s.statLabel}>more bookings</p>
                    </div>
                </div>
                <div className={s.actions}>
                    <div className={s.buttons}>
                        <Button type="primary" onClick={onSetupClick}>
                            Set up Pro-listing
                        </Button>
                        <Button onClick={() => setShowWebinarBooking(true)}>Talk to specialist</Button>
                    </div>
                    <p className={s.disclaimer}>
                        Actual visibility depends on your bids versus competition in your specialty and state. Metrics
                        shown are averages across Pro-Listing providers in your area.
                    </p>
                </div>
            </div>
            <WebinarBooking
                modalHeader={
                    <div>
                        <div className={s.webinarTitle}>Talk to a Pro-Listings specialist</div>
                        <div className={s.webinarDesc}>
                            Want to grow faster with pro listings? Book a time to speak with our specialist and get
                            personalized guidance.
                        </div>
                    </div>
                }
                show={showWebinarBooking}
                link={CALENDLY_LINK.PRO_LISTINGS_SPECIALIST}
                webinarScheduleType={EWebinarScheduleType.PRO_LISTINGS_SPECIALIST}
                onClose={() => setShowWebinarBooking(false)}
            />
        </div>
    );
};

export default ProListingUpsellCard;
